import {
  SELECTION_STATES_ORDERED,
  SELECTION_STATES_ORDERED_V2,
} from '../constants'

import type { SelectionCandidateState } from 'api/bcks/useAPIBCKSInvitation'

export const getIsSelectionStatePassed = (
  currentState: SelectionCandidateState,
  state: SelectionCandidateState
) => {
  return (
    SELECTION_STATES_ORDERED.findIndex((s) => s === currentState) >
    SELECTION_STATES_ORDERED.findIndex((s) => s === state)
  )
}

export const getIsSelectionStatePassedV2 = (
  currentState: SelectionCandidateState,
  state: SelectionCandidateState
) => {
  return (
    SELECTION_STATES_ORDERED_V2.findIndex((s) => s === currentState) >
    SELECTION_STATES_ORDERED_V2.findIndex((s) => s === state)
  )
}

export const getIsSelectionStateDone = (
  currentState: SelectionCandidateState,
  state: SelectionCandidateState
) => {
  return (
    currentState === state || getIsSelectionStatePassed(currentState, state)
  )
}
